export default __webpack_public_path__ + "static/usb_c_xr_charging_adapter_m-82838bcb893e7fd49e409d7f5bb30eaf.png";